export default {
  jpath: ['stock'],
  getEmpty() {
    return {};
  },
};
